import { useCallback, type RefObject } from 'react';
import type { MapRef } from 'react-map-gl/mapbox';
import { useSelectedVehicleStore } from '../store/useSelectedVehicleStore';
import { useGcsStore } from '../store/useGcsStore';
import { fitMapToCoordinates, getCenterFocusCoordinates } from '../utils/map';

/**
 * Focuses the map on all assets belonging to a single center:
 * control zone, launchpads, all live mission points, routes,
 * failure-mode routes/safe points, drones and foreign aircraft.
 */
export const useFocusCenter = (mapRef: RefObject<MapRef | null>, gcsId: string) => {
  const selectedVehicle = useSelectedVehicleStore((state) => state.selectedVehicle);

  return useCallback(() => {
    if (!mapRef.current) {
      return;
    }

    const gcsData = useGcsStore.getState().data.get(gcsId);
    if (!gcsData) return;

    const allMissionIds = new Set(Array.from(gcsData.liveMissionsMap.values()).map((mission) => mission.missionId));

    const coordinates = getCenterFocusCoordinates(gcsData, allMissionIds);
    if (coordinates.length === 0) return;

    fitMapToCoordinates(mapRef.current, coordinates, !!selectedVehicle);
  }, [gcsId, mapRef, selectedVehicle]);
};
